import { render, staticRenderFns } from "./OrderWizard.vue?vue&type=template&id=3e82b8bc&"
import script from "./OrderWizard.vue?vue&type=script&lang=js&"
export * from "./OrderWizard.vue?vue&type=script&lang=js&"
import style0 from "./OrderWizard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports